module.exports = __webpack_public_path__ + "7a5de0dec4d8c4b96988e2e66ab618f2.pdf";